<template>
    <div class="load">
        <div class="load_img">
            <div class="box-load">
                <img src="../../assets/search/loading.gif" alt="loading"/>
                <span class="loading_txt">正在加载</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name:"load",
    }
</script>

<style scoped>
    .load{position: relative;z-index: 19}
    .load_img {height: 330px;text-align: center;vertical-align: middle;display: flex;align-items: center;justify-content: center;}
    .loading_txt{font-size: 18px;letter-spacing: 0px;color: #666666;display: block;padding-top: 20px;}
</style>

